import * as React from "react";

class DialogGText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogG-text dialogGHI-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 344.176 294.544"
      >
        <g>
          <path
            fill="#F17752"
            d="M65.6,82.3c0.6,0.7,2.2,2.5,2.5,2.9l-1.1,2.1c-0.3-0.6-0.8-1.5-1.4-2.3v8.2h-2.1v-6.7
		c-0.5,1.3-1.2,2.6-1.8,3.5c-0.2-0.6-0.7-1.4-1.1-2c1.2-1.6,2.2-4.1,2.8-6.3h-2.3v-2h2.4v-3.3h2.1v3.3h2.1v2h-2.1V82.3z M77.4,82.3
		h-2.2v8.2c0,1.3-0.3,1.9-1.1,2.3c-0.8,0.4-2,0.4-3.8,0.4c-0.1-0.6-0.5-1.7-0.8-2.3c1.3,0.1,2.6,0.1,3,0.1c0.4,0,0.5-0.1,0.5-0.5
		v-8.2h-4.9v-2.1H73v-3.7h2.2v3.7h2.2V82.3z M70.2,88.5c-0.3-1.2-1.1-3-1.8-4.3l1.8-0.7c0.8,1.3,1.6,3,1.9,4.2L70.2,88.5z"
          />
          <path
            fill="#F17752"
            d="M94.6,87.8c-1,0.7-2.1,1.4-3.2,2c1.1,0.7,2.5,1.2,4.1,1.5c-0.5,0.4-1.1,1.3-1.4,1.9c-4-0.9-6.4-3-8-6.3h-2.6
		v3.8l3.9-0.8c-0.1,0.6-0.2,1.5-0.2,1.9c-4.3,1-5.3,1.2-5.8,1.4l-0.1,0.1c-0.1-0.5-0.6-1.6-0.9-2.1c0.4-0.2,0.9-0.6,0.9-1.4v-2.9H79
		V85h3v-8h11.4v1.7h-9.2v1h8.7v1.7h-8.7v0.9h8.7V84h-8.7v1h11.1v1.9h-1.9L94.6,87.8z M88.5,86.9c0.4,0.7,0.9,1.3,1.5,1.8
		c0.9-0.6,1.9-1.2,2.6-1.8H88.5z"
          />
          <path
            fill="#F17752"
            d="M111.7,89.4c0.5,0.3,1.3,0.6,1.8,0.7c-0.2,2.4-0.8,3-2.6,3h-2.8c-2.3,0-2.8-0.6-2.8-2.6v-2.9
		c-1,2.4-3.1,4.4-7.4,5.5c-0.2-0.6-0.7-1.4-1.2-1.8c3.6-0.9,5.4-2.3,6.4-4.1h-4.5v-4.2c-0.2,0.2-0.4,0.3-0.6,0.5
		c-0.3-0.5-1-1.3-1.5-1.6c2.5-1.6,4.2-3.8,5.1-5.7l2.3,0.4c-0.1,0.3-0.3,0.6-0.5,0.8h3.6l0.3-0.1l1.5,1c-0.5,0.8-1.1,1.7-1.7,2.5h5
		v6.4h-2.4C110.3,88,111.3,88.8,111.7,89.4L111.7,89.4z M103.7,85.5c0.2-0.8,0.3-1.7,0.4-2.6h-3.4v2.6H103.7z M102.2,79.4
		c-0.4,0.6-0.8,1.1-1.3,1.6h3.7c0.4-0.5,0.8-1,1.2-1.6H102.2z M109.8,82.9h-3.5c-0.1,0.9-0.2,1.8-0.4,2.6h3.9V82.9z M110.7,91.2
		c0.6,0,0.8-0.3,0.9-1.7l-1.3,1.2c-0.5-0.6-1.5-1.7-2.3-2.4l1.2-1h-1.7v3.2c0,0.6,0.1,0.7,0.9,0.7H110.7z"
          />
          <path
            fill="#F17752"
            d="M129.7,89.4c0.5,0.3,1.3,0.6,1.8,0.7c-0.2,2.4-0.8,3-2.6,3h-2.8c-2.3,0-2.8-0.6-2.8-2.6v-2.9
		c-1,2.4-3.1,4.4-7.4,5.5c-0.2-0.6-0.7-1.4-1.2-1.8c3.6-0.9,5.4-2.3,6.4-4.1h-4.5v-4.2c-0.2,0.2-0.4,0.3-0.6,0.5
		c-0.3-0.5-1-1.3-1.5-1.6c2.5-1.6,4.2-3.8,5.1-5.7l2.3,0.4c-0.1,0.3-0.3,0.6-0.5,0.8h3.6l0.3-0.1l1.5,1c-0.5,0.8-1.1,1.7-1.7,2.5h5
		v6.4h-2.4C128.3,88,129.3,88.8,129.7,89.4L129.7,89.4z M121.7,85.5c0.2-0.8,0.3-1.7,0.4-2.6h-3.4v2.6H121.7z M120.2,79.4
		c-0.4,0.6-0.8,1.1-1.3,1.6h3.7c0.4-0.5,0.8-1,1.2-1.6H120.2z M127.8,82.9h-3.5c-0.1,0.9-0.2,1.8-0.4,2.6h3.9V82.9z M128.7,91.2
		c0.6,0,0.8-0.3,0.9-1.7l-1.3,1.2c-0.5-0.6-1.5-1.7-2.3-2.4l1.2-1h-1.7v3.2c0,0.6,0.1,0.7,0.9,0.7H128.7z"
          />
          <path
            fill="#F17752"
            d="M138.1,85.6c0,0.3-0.1,0.5-0.1,0.7c0.9,0.9,2.9,3.2,3.4,3.8l-1.4,1.8c-0.6-0.9-1.6-2.3-2.5-3.4
		c-0.6,1.8-1.7,3.5-3.4,4.7c-0.3-0.5-1.1-1.3-1.5-1.6c2.3-1.7,3.2-3.9,3.5-6h-3.2v-2h3.3v-0.4v-2.4h-0.7c-0.4,0.9-0.8,1.7-1.2,2.4
		c-0.4-0.4-1.2-1-1.7-1.2c1-1.3,1.7-3.4,2-5.4l2.1,0.4c-0.1,0.6-0.3,1.2-0.5,1.9h4.8v2h-2.5v2.4v0.4h3v2H138.1z M148.6,78v14.5h-2.2
		v-1h-2.6v1.3h-2.1V78H148.6z M146.4,89.4V80h-2.6v9.4H146.4z"
          />
          <path
            fill="#F17752"
            d="M153.1,89.8v1.4h-1.9V77.7h5.1v12.1H153.1z M153.1,79.6v3.2h1.3v-3.2H153.1z M154.4,87.9v-3.3h-1.3v3.3H154.4z
		 M165.6,91.2c0.3,0,0.4-0.1,0.4-1.4c0.4,0.3,1.2,0.6,1.7,0.8c-0.2,2-0.7,2.5-1.9,2.5h-1.4c-1.6,0-2-0.6-2-2.3v-2.1h-1.4
		c-0.3,2.4-1.3,3.8-4.7,4.6c-0.2-0.5-0.7-1.3-1.1-1.7c2.8-0.5,3.5-1.3,3.8-2.9h-2.5V87h10.9v1.7h-3v2.1c0,0.5,0,0.5,0.3,0.5H165.6z
		 M156.7,85.1c0.5,0,1-0.1,1.6-0.1v-0.9H157v-1.4h1.3v-0.9h-1.6v-1.6h4.2v-0.9h-3.3v-1.6h3.3v-1.1h2v1.1h3.4v1.6H163v0.9h4.3v1.6
		h-1.8v0.9h1.5v1.4h-1.5v0.9h1.9v1.4h-5.5v-1.4h1.9v-0.9h-1.4v-1.4h1.4v-0.9H160v0.9h1.4v1.4H160v0.8l1.5-0.1l0,1.4
		c-1.6,0.2-3.2,0.4-4.6,0.6L156.7,85.1z"
          />
          <path
            fill="#F17752"
            d="M174.5,77.1c-0.5,1.3-1.1,2.6-1.8,3.8v12.2h-2.1v-9.1c-0.4,0.5-0.8,0.9-1.1,1.3c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L174.5,77.1z M182.3,91.2c1.1,0,1.3-0.5,1.4-2.5c0.5,0.3,1.3,0.7,1.9,0.8c-0.3,2.7-0.9,3.6-3.1,3.6h-4.1
		c-2.5,0-3.2-0.6-3.2-3.2v-5l-1.4,0.5l-0.8-1.9l2.2-0.8v-4.2h2v3.4l1.8-0.7v-4.7h1.9v3.9l2.4-0.9l0.2-0.1l1.6,0.5l-0.1,0.3
		c-0.1,2.6-0.3,6-0.7,8.2l-1.8-0.5c0.2-1.5,0.3-3.9,0.4-6.1l-2,0.8V89h-1.9v-5.6l-1.8,0.7v5.8c0,1.1,0.2,1.2,1.4,1.2H182.3z"
          />
          <path
            fill="#F17752"
            d="M203,79.2c0,0,0,0.7,0,1c-0.2,8-0.4,10.9-1.2,11.9c-0.5,0.7-1,0.9-1.7,1c-0.7,0.1-1.8,0.1-2.8,0
		c0-0.6-0.3-1.5-0.7-2.1c1.2,0.1,2.2,0.1,2.7,0.1c0.4,0,0.6-0.1,0.8-0.3c0.5-0.6,0.8-3.3,1-9.6h-3.9c-0.5,1.1-1,2.1-1.6,2.8
		c-0.3-0.3-0.9-0.7-1.4-1v8.4h-4.8v1.3h-1.9V79.3h2c0.2-0.9,0.5-2.1,0.5-2.9l2.3,0.3c-0.3,0.9-0.6,1.8-0.9,2.6h2.8v2.9
		c1-1.5,1.9-3.7,2.4-5.8l2,0.5c-0.2,0.8-0.4,1.5-0.7,2.3H203z M192.2,81.2h-2.9v2.9h2.9V81.2z M192.2,89.5V86h-2.9v3.5H192.2z
		 M198.2,88.5c-0.5-1.1-1.6-2.8-2.5-4.2l1.7-1c0.9,1.2,2.1,3,2.6,4L198.2,88.5z"
          />
          <path
            fill="#F17752"
            d="M219.6,87c-0.5-0.6-1.4-1.3-2.3-2.1c-0.4,0.6-0.8,1.1-1.2,1.5c-0.3-0.3-0.9-0.6-1.4-0.9c1.6,2.1,4.2,4,6.9,5
		c-0.5,0.5-1.2,1.4-1.6,2c-2.2-1-4.2-2.6-5.8-4.6v5.2h-2.3v-5.1c-1.6,1.9-3.6,3.5-5.8,4.4c-0.3-0.5-1-1.4-1.5-1.8
		c2.9-1.1,5.7-3.4,7.3-5.8v-4.2h-6.6v-2.1h6.6v-2.2h2.3v2.2h6.8v2.1h-6.8v4c0.1,0.1,0.2,0.3,0.3,0.4c1.2-1,1.9-2.6,2.3-4.3l2.1,0.4
		c-0.2,0.7-0.4,1.3-0.6,1.9c1,0.8,2.3,1.7,2.9,2.4L219.6,87z M210.3,81.3c-0.2,0.7-0.4,1.3-0.6,1.9c0.6,0.6,1.3,1.2,1.7,1.6
		l-1.4,1.5c-0.3-0.3-0.7-0.8-1.2-1.3c-0.6,1-1.3,1.8-2.1,2.5c-0.3-0.4-1.2-1.1-1.7-1.4c1.6-1.1,2.7-3,3.2-5.2L210.3,81.3z"
          />
          <path
            fill="#F17752"
            d="M222.8,91.8c0.9-0.8,1.7-2,2.2-3.1l1.8,0.8c-0.5,1.1-1.3,2.4-2.2,3.3L222.8,91.8z M238.9,82h-15.6v-1.7h3.8
		c-0.1-0.3-0.2-0.7-0.4-1l1.4-0.3h-3.9v-1.7h5.8c-0.1-0.3-0.2-0.6-0.3-0.8l2.1-0.4c0.2,0.4,0.4,0.8,0.5,1.2h5.6v1.7h-3.7l1.4,0.3
		c-0.2,0.4-0.4,0.7-0.6,1h3.8V82z M236.9,88.1h-5.5c0.7,0.4,1.4,0.8,1.9,1.2l-1.3,1.3c-0.6-0.6-1.8-1.3-2.8-1.8l0.7-0.7h-4.6v-5.5
		h11.6V88.1z M232.7,91.3c0.7,0,0.8-0.2,0.9-1.5c0.4,0.3,1.3,0.6,1.8,0.7c-0.2,2-0.8,2.5-2.5,2.5H230c-2.3,0-2.8-0.5-2.8-2.2v-1.9
		h2.1v1.9c0,0.5,0.1,0.5,1,0.5H232.7z M234.8,84h-7.5v0.8h7.5V84z M234.8,86h-7.5v0.8h7.5V86z M228.7,79.1c0.2,0.4,0.4,0.9,0.5,1.3
		h3.7c0.2-0.4,0.4-0.9,0.5-1.3H228.7z M236.9,88.5c0.9,1,1.8,2.3,2.2,3.2l-1.9,0.8c-0.3-0.9-1.2-2.2-2.1-3.3L236.9,88.5z"
          />
          <path
            fill="#F17752"
            d="M246.9,89.8h-3.7v1.6h-2V77.5h5.6V89.8z M243.2,79.4v3.2h1.7v-3.2H243.2z M244.9,87.9v-3.4h-1.7v3.4H244.9z
		 M253.3,80.2v1.7h3.6v1.9h-1.3v1.4h1.7v1.9h-1.7V91c0,1-0.2,1.6-0.9,1.9c-0.7,0.3-1.7,0.4-3,0.4c-0.1-0.6-0.4-1.4-0.7-2
		c0.9,0,1.9,0,2.1,0c0.3,0,0.4-0.1,0.4-0.3v-3.9h-6.3v-1.9h6.3v-1.4h-5.7v-1.9h3.5v-1.7h-4.1v-1.9h4.1v-1.9h2.1v1.9h4.1v1.9H253.3z
		 M249.7,87.3c0.7,0.9,1.7,2.1,2.2,2.9l-1.9,1.1c-0.4-0.8-1.3-2.1-2.1-3L249.7,87.3z"
          />
          <path
            fill="#F17752"
            d="M260.1,93.3c1.4-0.5,2.2-1.2,2.3-2.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.6-1.7-1.6c0-1,0.8-1.6,1.8-1.6
		c1.3,0,1.9,1,1.9,2.5c0,2-1.3,3.7-3.5,4.4L260.1,93.3z"
          />
          <path
            fill="#F17752"
            d="M279.4,87.5c-0.2,0.9-0.6,1.8-1.1,2.6c1.8,0.6,3.9,0.9,6.4,1c-0.5,0.5-1,1.4-1.3,2c-2.6-0.2-4.8-0.7-6.6-1.5
		c-0.9,0.6-2.1,1.2-3.5,1.7c-0.3-0.5-0.9-1.3-1.3-1.8c1.2-0.3,2.2-0.6,2.9-1c-0.8-0.6-1.5-1.3-2.1-2.1l1.9-0.6
		c0.5,0.6,1.1,1.1,1.8,1.5c0.5-0.5,0.7-1.1,0.9-1.7h-3.9v-7.2h4.1v-1.1h-4.4v-1.6c-0.4,1.1-0.9,2.2-1.5,3.3v12.2h-2.1v-8.9
		c-0.3,0.4-0.6,0.8-0.9,1.2c-0.2-0.5-0.8-1.7-1.2-2.2c1.5-1.6,3-4.2,3.8-6.8l2,0.6l-0.1,0.2h10.9v1.9h-4.5v1.1h4.1v7.2H279.4z
		 M275.4,83.2h2.2v-1.3h-2.2V83.2z M277.5,86c0-0.2,0-0.5,0-0.7v-0.6h-2.2V86H277.5z M281.7,84.6h-2v0.6c0,0.2,0,0.5,0,0.7h2V84.6z
		 M279.7,81.9v1.3h2v-1.3H279.7z"
          />
          <path
            fill="#F17752"
            d="M76.2,112.8c0,0.9-0.2,1.3-0.9,1.5c-0.6,0.2-1.6,0.2-2.8,0.2c-0.1-0.5-0.4-1.1-0.7-1.5c0.8,0,1.6,0,1.9,0
		c0.3,0,0.3-0.1,0.3-0.3v-0.7h-4.1v2.8H68v-2.8h-3.7v2.5h-2.1v-4H68V110h-4.8v-4.4h5c0.1-0.3,0.2-0.6,0.3-0.8
		c-2.6,0.2-5.3,0.4-7.2,0.5L61,104c0.9,0,1.9-0.1,3.1-0.1v-0.6h-2.6v-1.1h2.6v-0.5h-3v-1.1h3V100h-2.3v-1h2.3V98h2V99h2.4v1h-2.4
		v0.6h3v1.1h-3v0.5h2.6v1.1h-2.6v0.5c1-0.1,2.1-0.1,3.1-0.2l0,1l1.3,0.3c-0.2,0.3-0.4,0.6-0.5,0.8h5.2v4.4h-5.1v0.6h6.2V112.8z
		 M65,107.3h8.2v-0.5H65V107.3z M65,108.9h8.2v-0.5H65V108.9z M77.2,99.5v1.5h-1.7v2.5c0,0.8-0.2,1.2-0.7,1.4
		c-0.6,0.2-1.3,0.3-2.4,0.3c-0.1-0.5-0.5-1.1-0.7-1.5c0.6,0,1.4,0,1.6,0c0.2,0,0.3-0.1,0.3-0.3V101h-2.4c0.6,0.6,1.2,1.4,1.5,2
		l-1.5,0.8c-0.3-0.6-0.9-1.5-1.4-2.1l1.3-0.7h-1.9v-1.5h4.3V98h2v1.4H77.2z"
          />
          <path
            fill="#F17752"
            d="M84.5,98.7c-0.5,1.3-1.1,2.6-1.8,3.8v12.2h-2.1v-9.1c-0.4,0.5-0.8,0.9-1.1,1.3c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L84.5,98.7z M92.3,112.8c1.1,0,1.3-0.5,1.4-2.5c0.5,0.3,1.3,0.7,1.9,0.8c-0.3,2.7-0.9,3.6-3.1,3.6h-4.1
		c-2.5,0-3.2-0.6-3.2-3.2v-5l-1.4,0.5l-0.8-1.9l2.2-0.8V100h2v3.4l1.8-0.7v-4.7h1.9v3.9l2.4-0.9l0.2-0.1l1.6,0.5l-0.1,0.3
		c-0.1,2.6-0.3,6-0.7,8.2l-1.8-0.5c0.2-1.5,0.3-3.9,0.4-6.1l-2,0.8v6.4h-1.9v-5.6l-1.8,0.7v5.8c0,1.1,0.2,1.2,1.4,1.2H92.3z"
          />
          <path
            fill="#F17752"
            d="M101.6,108.4c-0.2-0.5-0.6-1.3-0.9-2v8.5h-1.7v-7.6c-0.4,1.5-0.9,2.9-1.4,3.9c-0.2-0.6-0.6-1.6-0.8-2.1
		c0.8-1.3,1.6-3.6,2-5.6h-1.5v-2h1.8V98h1.7v3.3h1.4v0.7c2-1.1,3.8-2.7,4.8-4.3l2,0.7c-0.1,0.2-0.2,0.4-0.3,0.5
		c1.3,1.1,3.3,2.1,5.1,2.7c-0.3,0.5-0.7,1.5-0.8,2c-0.8-0.4-1.7-0.8-2.5-1.3v1.2h-5.3v-1c-0.6,0.4-1.2,0.8-1.8,1.1
		c-0.2-0.3-0.7-0.8-1.1-1.2v0.8h-1.4v0.8c0.4,0.6,1.6,2.4,1.8,2.8L101.6,108.4z M106,109.7c-0.1,0.4-0.3,0.7-0.4,1.1
		c0.6,0.4,1.3,0.9,1.7,1.3l-1.1,1.4c-0.3-0.4-0.9-0.8-1.4-1.2c-0.7,1.1-1.6,2-2.6,2.7c-0.3-0.4-1-1.1-1.4-1.4
		c1.6-0.9,2.7-2.4,3.3-4.3L106,109.7z M102.7,104.6h4.4v4.5h-4.4V104.6z M104.3,107.7h1.2V106h-1.2V107.7z M109.5,102.1
		c-0.8-0.5-1.5-1-2.1-1.6c-0.5,0.6-1.1,1.1-1.7,1.6H109.5z M111,109.5c-0.1,0.5-0.2,1-0.4,1.5c1,0.7,2.2,1.5,2.8,2.2l-1.3,1.4
		c-0.5-0.5-1.4-1.3-2.3-1.9c-0.5,0.9-1.2,1.7-2,2.2c-0.3-0.4-1-1.1-1.3-1.4c1.4-0.9,2.3-2.4,2.6-4.3L111,109.5z M107.9,104.6h4.5
		v4.5h-4.5V104.6z M109.4,107.7h1.3V106h-1.3V107.7z"
          />
          <path
            fill="#F17752"
            d="M117.8,105.9c-0.6,0.4-1.2,0.6-1.9,0.9c-0.3-0.5-0.9-1.3-1.4-1.7c2-0.6,3.9-1.8,5.3-3.2h-4.8V100h6.9v-2h2.1v2
		h7v1.9h-4.6c1.7,1.1,3.5,2.3,4.6,3.2l-1.4,1.5c-1.2-1.1-3.7-2.8-5.7-4.1v2.6h-2.1v-2.7c-1,1.2-2.3,2.4-3.7,3.2h10v6h-10.4V105.9z
		 M115.2,112.5h15.7v1.9h-15.7V112.5z M119.9,107.9h6V107h-6V107.9z M119.9,110.2h6v-0.9h-6V110.2z"
          />
          <path
            fill="#F17752"
            d="M147.4,112.7c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1h-1.2c-1.6,0-2-0.6-2-2.5
		v-3.6h-0.8c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8h-1.8v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7h-1.2v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1h-5.6V101h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6c0.4,0.7,0.8,1.7,1,2.3
		l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1c1.4,1.4,3.1,3.4,3.8,4.8
		L148,104c-0.1-0.2-0.2-0.4-0.4-0.6v5.1h-1.1v3.6c0,0.5,0,0.6,0.3,0.6H147.4z M138.5,105.1h-5.1v-1.6h5.1V105.1z M133.4,105.9h5.1
		v1.6h-5.1V105.9z M136.9,110.1h-1.7v2h1.7V110.1z M142.4,106.7h3.2v-2h-3.2V106.7z"
          />
          <path
            fill="#F17752"
            d="M152.8,102.3c0-1,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,1-0.8,1.7-1.7,1.7S152.8,103.3,152.8,102.3z M152.8,110.9
		c0-1,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,1-0.8,1.7-1.7,1.7S152.8,111.9,152.8,110.9z"
          />
          <path fill="#F17752" d="M62.9,119.5h6v1.9H65v9.6h-2.1V119.5z" />
          <path
            fill="#F17752"
            d="M85.6,128.2c-0.8,1.5-1.8,2.8-3,3.9c0.5,1.4,1,2.2,1.6,2.2c0.4,0,0.6-0.9,0.7-3c0.5,0.5,1.2,1,1.8,1.2
		c-0.3,3.2-1,3.9-2.6,3.9c-1.3,0-2.3-1.1-3.1-2.8c-1,0.9-2.2,1.6-3.3,2.2c-0.3-0.5-0.9-1.2-1.4-1.7c1.4-0.6,2.8-1.5,4-2.5
		c-0.4-1.4-0.7-3.1-0.9-4.8h-3.7v2.1c0.9-0.2,1.9-0.3,2.8-0.5l0.2,1.9l-2.9,0.6v3.1c0,1.2-0.3,1.7-1,2.1c-0.7,0.3-1.8,0.4-3.2,0.4
		c-0.1-0.6-0.5-1.6-0.8-2.2c1,0.1,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2.6c-1.2,0.2-2.3,0.5-3.2,0.6l-0.5-2.2c1-0.2,2.3-0.4,3.7-0.6
		v-2.4H70v-2h3.4v-2.1c-1,0.2-2,0.3-2.9,0.4c-0.1-0.5-0.4-1.3-0.6-1.8c2.5-0.3,5.3-0.9,7.1-1.5l1.4,1.8c-0.9,0.3-1.9,0.5-2.9,0.7
		v2.4H79c-0.1-1.6-0.2-3.3-0.2-4.9h2.3c0,1.7,0,3.3,0.2,4.9h4.9v2h-4.7c0.1,1.1,0.3,2.1,0.5,3c0.6-0.8,1.2-1.6,1.7-2.4L85.6,128.2z
		 M84.3,124.2c-0.5-0.8-1.6-2.1-2.6-3l1.6-1.1c1,0.8,2.1,2,2.7,2.9L84.3,124.2z"
          />
          <path
            fill="#F17752"
            d="M93.1,128.8c0,0.3-0.1,0.5-0.1,0.7c0.9,0.9,2.9,3.2,3.4,3.8l-1.4,1.8c-0.6-0.9-1.6-2.3-2.5-3.4
		c-0.6,1.8-1.7,3.5-3.4,4.7c-0.3-0.5-1.1-1.3-1.5-1.6c2.3-1.7,3.2-3.9,3.5-6h-3.2v-2h3.3v-0.4v-2.4h-0.7c-0.4,0.9-0.8,1.7-1.2,2.4
		c-0.4-0.4-1.2-1-1.7-1.2c1-1.3,1.7-3.4,2-5.4l2.1,0.4c-0.1,0.6-0.3,1.2-0.5,1.9h4.8v2h-2.5v2.4v0.4h3v2H93.1z M103.6,121.2v14.5
		h-2.2v-1h-2.6v1.3h-2.1v-14.7H103.6z M101.4,132.6v-9.4h-2.6v9.4H101.4z"
          />
          <path
            fill="#F17752"
            d="M110.7,128c-0.3,1.6-0.8,3.3-1.4,4.7c0.3,0.2,0.6,0.4,1.1,0.7c1.2,0.7,2.9,0.8,5,0.8c2.1,0,5.3-0.2,7.3-0.5
		c-0.3,0.6-0.6,1.6-0.6,2.2c-1.5,0.1-4.7,0.2-6.8,0.2c-2.4,0-3.9-0.2-5.2-1c-0.8-0.4-1.4-1-1.8-1c-0.4,0-1,1.2-1.5,2.3l-1.4-2
		c0.6-0.8,1.3-1.4,1.9-1.7c0.4-0.9,0.8-2,1-3.1h-2.3c0.4-1.1,0.9-2.5,1.3-3.9h-1.6v-1.9h4.2c-0.4,1.3-0.8,2.7-1.2,4h0.7l0.3-0.1
		L110.7,128z M107.7,123.3c-0.2-0.8-0.7-2.1-1-3.1l1.9-0.6c0.3,1,0.8,2.2,1,3L107.7,123.3z M114.8,124.4c0.1-0.3,0.1-0.6,0.2-0.9
		h-4.3v-1.7h2.4c-0.2-0.5-0.6-1-0.8-1.4l1.7-0.7c0.4,0.6,0.9,1.3,1.2,1.8l-0.6,0.3h2.7c0.4-0.6,0.9-1.5,1.1-2.1l2.1,0.6
		c-0.4,0.6-0.7,1.1-1.1,1.6h2.9v1.7h-4.9c-0.1,0.3-0.3,0.6-0.4,0.9h3.9v8.7h-8.7v-8.7H114.8z M118.7,125.9h-4.6v1h4.6V125.9z
		 M118.7,128.3h-4.6v1h4.6V128.3z M118.7,130.6h-4.6v1h4.6V130.6z"
          />
          <path
            fill="#F17752"
            d="M139.5,122c-1.7,1.8-3.9,3.7-6.2,5v7c0,1.2-0.3,1.8-1.2,2.1c-0.9,0.3-2.2,0.4-3.9,0.4
		c-0.1-0.6-0.5-1.6-0.9-2.2c1.3,0.1,2.8,0,3.2,0c0.4,0,0.5-0.1,0.5-0.4v-8c1.4-0.7,3-1.9,4.1-3h-10.4v-2.1h12.5l0.5-0.1L139.5,122z"
          />
          <path
            fill="#F17752"
            d="M143.7,133.3c0-1,0.8-1.8,1.9-1.8s1.9,0.8,1.9,1.8c0,1-0.8,1.8-1.9,1.8S143.7,134.3,143.7,133.3z M144,124.1
		l-0.1-2.7h3.3l-0.1,2.7l-0.6,6.2h-1.9L144,124.1z"
          />
          <path
            fill="#F17752"
            d="M155.9,128.3c-0.3,1.6-0.8,3.2-1.5,4.5c0.3,0.2,0.6,0.4,1,0.6c1.2,0.7,3,0.8,5,0.8c2,0,5.3-0.2,7.3-0.5
		c-0.3,0.6-0.6,1.7-0.6,2.3c-1.5,0.1-4.6,0.2-6.8,0.2c-2.4,0-3.9-0.2-5.2-0.9c-0.8-0.4-1.4-0.9-1.7-0.9c-0.4,0-1.1,1.2-1.6,2.1
		l-1.4-2.1c0.5-0.6,1.1-1.2,1.7-1.5c0.6-0.9,1.2-2.1,1.5-3.2h-2.5c0.5-1.1,1-2.5,1.5-3.9h-1.8v-1.9h4.5c-0.4,1.3-1,2.7-1.4,4h0.5
		l0.3-0.1L155.9,128.3z M152.8,123.3c-0.3-0.8-0.9-2.1-1.3-3.1l1.9-0.7c0.5,1,1,2.2,1.4,3L152.8,123.3z M167.2,123.3h-11.5v-1.7h4.8
		c-0.2-0.5-0.5-1.1-0.8-1.5l2.1-0.6c0.4,0.6,0.8,1.4,1.1,1.9l-0.7,0.2h5V123.3z M156.8,128.6h9v4.6h-9V128.6z M165.7,125.5H157V124
		h8.6V125.5z M157,126.3h8.6v1.5H157V126.3z M158.8,131.7h4.9v-1.5h-4.9V131.7z"
          />
          <path
            fill="#F17752"
            d="M173.9,120.3c-0.4,1.1-0.9,2.3-1.4,3.4v12.8h-2v-9.2c-0.4,0.6-0.8,1.1-1.2,1.5c-0.2-0.5-0.7-1.8-1-2.3
		c1.5-1.6,2.9-4.2,3.7-6.8L173.9,120.3z M184.9,120.5v15.7h-2v-0.9h-6.8v1h-1.9v-15.9H184.9z M182.9,133.5v-11.1h-6.8v11.1H182.9z
		 M180.3,126.2v1.5h1.7v4.8h-5v-4.8h1.6v-1.5h-2.1v-1.5h2.1v-1.8h1.7v1.8h2.2v1.5H180.3z M180.4,129.2h-1.8v1.9h1.8V129.2z"
          />
          <path
            fill="#F17752"
            d="M196.3,134.1c0.5,0,1,0.1,1.4,0.1c1,0,4.5,0,5.7-0.1c-0.3,0.5-0.6,1.4-0.7,2.1h-5.1c-3.3,0-5.5-0.5-7-2.6
		c-0.6,1.2-1.5,2.1-2.5,2.9c-0.3-0.4-1.1-1.2-1.6-1.5c1.8-1.1,2.9-3,3.3-5.5l2.1,0.3c-0.1,0.6-0.3,1.1-0.4,1.6
		c0.6,1.2,1.4,1.9,2.6,2.3v-4.6h-7v-1.9H203v1.9h-6.7v1.3h5.5v1.9h-5.5V134.1z M201.3,126.5h-12.5v-6.2h12.5V126.5z M199.1,121.7
		h-8.2v0.9h8.2V121.7z M199.1,124.1h-8.2v0.9h8.2V124.1z"
          />
          <path
            fill="#F17752"
            d="M204.5,127.9c0.5-1.2,0.8-3.2,0.9-4.7l1.6,0.2c-0.1,1.5-0.4,3.7-0.8,5.1L204.5,127.9z M220.9,122.8v13.5h-2.2
		v-0.7h-5.1v0.8h-2.1v-10.4l-1.6,0.7c-0.1-0.7-0.5-1.8-0.9-2.8v12.5H207v-16.8h2.1v3.5l1.2-0.5c0.5,1.1,1.1,2.5,1.3,3.4v-3.2h3.1
		c0.2-1,0.5-2.2,0.5-3.1l2.5,0.3c-0.3,1-0.6,2-0.9,2.9H220.9z M213.6,124.9v3.3h5.1v-3.3H213.6z M218.7,133.5v-3.4h-5.1v3.4H218.7z"
          />
          <path
            fill="#F17752"
            d="M222.5,127.9c0.5-1.2,0.8-3.2,0.9-4.7l1.6,0.2c-0.1,1.5-0.4,3.7-0.8,5.1L222.5,127.9z M238.9,122.8v13.5h-2.2
		v-0.7h-5.1v0.8h-2.1v-10.4l-1.6,0.7c-0.1-0.7-0.5-1.8-0.9-2.8v12.5H225v-16.8h2.1v3.5l1.2-0.5c0.5,1.1,1.1,2.5,1.3,3.4v-3.2h3.1
		c0.2-1,0.5-2.2,0.5-3.1l2.5,0.3c-0.3,1-0.6,2-0.9,2.9H238.9z M231.6,124.9v3.3h5.1v-3.3H231.6z M236.7,133.5v-3.4h-5.1v3.4H236.7z"
          />
          <path
            fill="#F17752"
            d="M257.4,121.6v1.9h-11.8v3.4c0,2.9-0.4,7-2.9,9.5c-0.3-0.4-1.1-1.2-1.5-1.4c1.2-1.2,1.8-2.7,2.1-4.2
		c-0.6,0.4-1.3,0.8-2,1.2l-0.6-2c0.7-0.3,1.8-0.8,2.9-1.4c0-0.6,0-1.1,0-1.6v-0.5l-1.5,0.8c-0.2-0.9-0.7-2.3-1.2-3.4l1.5-0.8
		c0.5,0.9,1,2,1.2,2.9v-4.3h6.1c-0.1-0.5-0.3-1.1-0.4-1.6l2.3-0.4c0.2,0.6,0.5,1.4,0.7,2H257.4z M246,124.5h11.2v1.8h-4.9v1.3h4.6
		v6.8c0,0.9-0.2,1.4-0.8,1.8c-0.6,0.3-1.5,0.3-2.6,0.3c-0.1-0.6-0.4-1.4-0.7-1.9c0.7,0,1.5,0,1.7,0c0.2,0,0.3-0.1,0.3-0.3v-1.6
		l-1.3,1.2c-0.4-0.5-1.2-1.3-2-2.1c-0.5,0.9-1.2,1.7-2.3,2.4c-0.3-0.4-0.8-1-1.2-1.3v3.6h-1.9v-8.9h4.2v-1.3H246V124.5z M248,132.7
		c1.6-0.8,2.1-2.1,2.2-3.3H248V132.7z M254.8,129.4h-2.6c0,0.3-0.1,0.5-0.1,0.7c0.9,0.8,2.1,1.8,2.7,2.5V129.4z"
          />
          <path
            fill="#F17752"
            d="M272.6,131.4c0,0.3-0.1,0.7-0.1,1h1.9v1.5h-2.1c-0.2,0.9-0.4,1.4-0.6,1.7c-0.4,0.5-0.8,0.6-1.4,0.7
		c-0.5,0.1-1.3,0.1-2.2,0c0-0.4-0.2-1.1-0.4-1.5c0.7,0.1,1.3,0.1,1.6,0.1c0.3,0,0.4,0,0.6-0.2c0.1-0.1,0.2-0.4,0.3-0.8H267
		c-0.5,1-1.3,2-2.4,2.8c-0.4-0.3-1.2-0.9-1.7-1.1c0.8-0.5,1.4-1.1,1.8-1.7h-3.6c0.1-0.7,0.2-1.5,0.4-2.5h-2.8v-1.6h3
		c0.1-0.8,0.2-1.7,0.2-2.4h11c0,0,0,0.6,0,0.8c0,0.6-0.1,1.1-0.1,1.6h2.7v1.6H272.6z M275,126.7h-15.8v-1.5h6.8v-0.7h-4.8V123h4.8
		v-0.6h-6v-1.5h6v-1.3h2.1v1.3h6.3v1.5h-6.3v0.6h5.1v1.4h-5.1v0.7h6.9V126.7z M265.6,132.3c0.1-0.3,0.2-0.6,0.3-1h-2.4l-0.1,1H265.6
		z M263.7,129.8h2.5c0-0.3,0-0.6,0-0.9v0h-2.4L263.7,129.8z M270.5,132.3c0-0.3,0.1-0.6,0.1-1h-2.6c-0.1,0.3-0.1,0.6-0.3,1H270.5z
		 M268.1,129c0,0.3,0,0.5,0,0.8h2.6l0.1-0.9L268.1,129L268.1,129z"
          />
          <path
            fill="#F17752"
            d="M278.7,133.3c0-1,0.8-1.8,1.9-1.8s1.9,0.8,1.9,1.8c0,1-0.8,1.8-1.9,1.8S278.7,134.3,278.7,133.3z M279,124.1
		l-0.1-2.7h3.3l-0.1,2.7l-0.6,6.2h-1.9L279,124.1z"
          />
          <path
            fill="#F17752"
            d="M66.5,141.9c-0.5,1.3-1.1,2.6-1.8,3.8V158h-2.1v-9.1c-0.4,0.5-0.8,0.9-1.1,1.3c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L66.5,141.9z M74.3,156c1.1,0,1.3-0.5,1.4-2.5c0.5,0.3,1.3,0.7,1.9,0.8c-0.3,2.7-0.9,3.6-3.1,3.6h-4.1
		c-2.5,0-3.2-0.6-3.2-3.2v-5l-1.4,0.5l-0.8-1.9l2.2-0.8v-4.2h2v3.4l1.8-0.7v-4.7h1.9v3.9l2.4-0.9l0.2-0.1l1.6,0.5L77,145
		c-0.1,2.6-0.3,6-0.7,8.2l-1.8-0.5c0.2-1.5,0.3-3.9,0.4-6.1l-2,0.8v6.4h-1.9v-5.6l-1.8,0.7v5.8c0,1.1,0.2,1.2,1.4,1.2H74.3z"
          />
          <path
            fill="#F17752"
            d="M81.9,151.8c-0.4,1.8-1.1,3.6-1.8,4.8c-0.3-0.3-1.1-0.8-1.5-1c0.7-1,1.2-2.6,1.5-4.2L81.9,151.8z M87.1,145.2
		h-8.2v-1.9h3.4c-0.2-0.5-0.4-1.2-0.6-1.7l2-0.4c0.3,0.6,0.6,1.4,0.8,2.1h2.7V145.2z M84.2,150.9v5.1c0,0.9-0.1,1.3-0.7,1.6
		c-0.5,0.3-1.2,0.3-2.2,0.3c-0.1-0.5-0.3-1.3-0.6-1.8c0.6,0,1.2,0,1.3,0c0.2,0,0.3-0.1,0.3-0.2v-5h-2.6v-4.8h6.8v4.8H84.2z
		 M81.5,149.2h3v-1.5h-3V149.2z M85.9,151.2c0.6,1,1.1,2.3,1.3,3.2l-1.6,0.7c-0.2-0.9-0.7-2.2-1.2-3.3L85.9,151.2z M93.5,156.1
		c0.1,0,0.3,0,0.3-0.1c0.1,0,0.1-0.2,0.2-0.5c0.1-0.3,0.1-1,0.1-2c0.4,0.4,1.1,0.7,1.6,0.9c0,0.8-0.1,1.8-0.2,2.2
		c-0.1,0.4-0.4,0.7-0.7,0.8c-0.3,0.2-0.7,0.2-1.1,0.2h-1.1c-0.4,0-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.9v-4.1
		c-0.6,2.6-1.6,5.1-3.5,6.9c-0.3-0.5-0.9-1-1.5-1.3c2.4-2.2,3.3-5.5,3.6-9.1h-2.1v-1.9h2.3c0.1-1.5,0.1-3.1,0.1-4.5h2
		c0,1.5,0,3-0.1,4.5h3.8v1.9h-3.9c0,0.3-0.1,0.6-0.1,0.9h1.4v6.8c0,0.3,0,0.5,0.1,0.6c0.1,0.1,0.1,0.1,0.3,0.1H93.5z M93.6,145.5
		c-0.3-0.8-1.1-2-1.8-2.9l1.4-0.8c0.7,0.8,1.5,2,1.9,2.8L93.6,145.5z"
          />
          <path
            fill="#F17752"
            d="M112.8,150.7c-0.6,0.3-1.2,0.6-1.7,0.9c0.5,1.6,1.4,3.1,2.6,3.9c-0.4,0.4-1,1.1-1.3,1.6
		c-1.3-1-2.3-2.8-2.8-4.8l-0.5,0.2c0.6,2,0.3,3.9-0.5,4.7c-0.5,0.6-1.1,0.8-1.8,0.8c-0.3,0-0.7,0-1.1,0c0-0.5-0.2-1.3-0.5-1.8
		c0.5,0.1,0.9,0.1,1.2,0.1c0.3,0,0.6-0.1,0.8-0.4c0.2-0.3,0.4-0.9,0.3-1.7c-1.5,1.2-3.5,2.4-5.2,3c-0.3-0.4-0.8-1.1-1.2-1.5
		c2.2-0.6,4.7-1.9,6.1-3.2c-0.1-0.2-0.1-0.4-0.2-0.6c-1.3,1-3.1,2-4.6,2.6c-0.3-0.4-0.8-1-1.1-1.3c1.7-0.5,3.8-1.4,5-2.4
		c-0.2-0.2-0.3-0.3-0.5-0.5c-1.1,0.7-2.4,1.4-3.5,1.8c-0.2-0.4-0.7-1-1.1-1.3c1.1-0.3,2.4-0.9,3.5-1.5h-2.2v-2.6
		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.3-0.4-0.8-1.1-1.2-1.4l0,0V158h-2.1v-9c-0.3,0.5-0.7,0.9-1,1.2c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.5-1.6,3-4.2,3.9-6.7l2,0.6c-0.4,1.2-1,2.5-1.6,3.7c1.8-1.3,3.1-3,3.8-4.4l2,0.4c-0.2,0.3-0.3,0.6-0.5,0.9h2.8l0.4-0.1l1.2,0.9
		c-0.4,0.6-0.8,1.2-1.3,1.7h3.3v4.2H107l-0.1,0c0.6,0.5,1.1,1.2,1.5,1.8c1-0.5,2.1-1.2,2.9-1.7L112.8,150.7z M104.9,144.1
		c-0.3,0.3-0.5,0.6-0.8,1h2.7c0.3-0.3,0.5-0.6,0.7-1H104.9z M104.3,147.7h2v-1.1h-2V147.7z M110.4,146.6h-2.1v1.1h2.1V146.6z"
          />
          <path
            fill="#F17752"
            d="M124.3,155.7c0.5,0,1,0.1,1.4,0.1c1,0,4.5,0,5.7-0.1c-0.3,0.5-0.6,1.4-0.7,2.1h-5.1c-3.3,0-5.5-0.5-7-2.6
		c-0.6,1.2-1.5,2.1-2.5,2.9c-0.3-0.4-1.1-1.2-1.6-1.5c1.8-1.1,2.9-3,3.3-5.5l2.1,0.3c-0.1,0.6-0.3,1.1-0.4,1.6
		c0.6,1.2,1.4,1.9,2.6,2.3v-4.6h-7v-1.9H131v1.9h-6.7v1.4h5.5v1.9h-5.5V155.7z M129.3,148.1h-12.5v-6.2h12.5V148.1z M127.1,143.3
		h-8.2v0.9h8.2V143.3z M127.1,145.7h-8.2v0.9h8.2V145.7z"
          />
          <path
            fill="#F17752"
            d="M148.7,145.6c-0.6,1.7-1.6,3.2-2.7,4.5c0.4,3.4,1.1,5.8,1.6,5.8c0.3,0,0.4-0.9,0.5-2.9c0.4,0.5,1.1,1,1.6,1.2
		c-0.3,3-0.9,3.7-2.3,3.7c-1.6,0-2.6-2.6-3.2-6.2c-0.3,0.3-0.7,0.5-1.1,0.7c-0.2-0.2-0.5-0.5-0.7-0.8h-2.1c0.5,0.8,1.1,1.9,1.4,2.5
		l-1.4,0.8c-0.2-0.5-0.6-1.3-1-2.1v3c0,0.5,0.1,0.5,0.5,0.5h1.3c0.4,0,0.5-0.3,0.5-1.9c0.3,0.2,0.7,0.4,1.2,0.5
		c-0.3-0.6-0.5-1.2-0.7-1.8l1.4-0.5c0.6,1.2,1.3,2.9,1.6,3.8l-1.5,0.6c-0.1-0.4-0.3-0.9-0.5-1.5c-0.2,1.7-0.7,2.1-1.8,2.1h-1.7
		c-1.6,0-1.9-0.5-1.9-1.9v-3.1h1.7l-0.3-0.6l1.1-0.5h-3.5v-4.2h5.9v3.1c0.5-0.3,1-0.7,1.5-1.1c-0.2-1.6-0.3-3.2-0.4-4.9h-7.4v0.8
		h6.9v1.4h-6.9c0,3.2-0.4,8.1-1.9,11.3c-0.4-0.3-1.2-1-1.7-1.1c1.5-3.1,1.7-7.6,1.7-10.6v-3.5h9.3c0-0.6,0-1.1,0-1.7h2.1v0.6
		l1.1-0.8c0.6,0.4,1.4,1,1.8,1.4l-0.7,0.5h1.4v1.7h-3.7c0,0.9,0.1,1.8,0.2,2.7c0.5-0.7,0.8-1.4,1.1-2.3L148.7,145.6z M135.2,156.8
		c0.3-1.1,0.6-2.8,0.8-4l1.4,0.5c-0.2,1.1-0.5,2.9-0.7,4L135.2,156.8z M140.7,149h-2.4v1.3h2.4V149z M146.6,142.9
		c-0.3-0.3-0.8-0.6-1.1-0.9c0,0.3,0,0.6,0,0.9H146.6z"
          />
          <path
            fill="#F17752"
            d="M166,142.1v6.4h-2.2v-4.9h-9.8v5H152v-6.5H166z M153.2,149h11.7v8.9h-2.1v-0.5h-7.5v0.6h-2.1V149z
		 M163.1,145.8H155v-1.4h8.1V145.8z M155,148.1v-1.4h8.1v1.4H155z M155.3,150.5v0.8h7.5v-0.8H155.3z M162.8,153.6v-0.8h-7.5v0.8
		H162.8z M162.8,155.8V155h-7.5v0.9H162.8z"
          />
          <path fill="#F17752" d="M185.4,148.3v2.3h-16.6v-2.3H185.4z" />
          <path
            fill="#F17752"
            d="M192,152.4c-0.2-0.5-0.6-1.3-1-2.1v7.8h-1.9v-6.7c-0.5,1.4-1,2.6-1.6,3.5c-0.2-0.6-0.6-1.4-0.9-1.9
		c1-1.4,2-3.9,2.4-6h-2v-2h2.2v-3.7h1.9v3.7h1.8v2H191v0.8c0.5,0.7,1.8,2.6,2.1,3.1L192,152.4z M196.9,153.1c-0.6,2.2-2,3.8-3.7,4.6
		c-0.2-0.4-0.8-1-1.1-1.4c1-0.5,1.9-1.3,2.5-2.3h-2v-1.4h2.8l0.3-0.1L196.9,153.1z M203.4,152.2c-0.9,0.6-1.8,1.3-2.6,1.8
		c0.8,0.8,1.9,1.5,3,1.9c-0.4,0.4-1,1.1-1.3,1.6c-1.3-0.6-2.4-1.6-3.3-2.9v1.4c0,0.9-0.2,1.4-0.8,1.7c-0.6,0.3-1.4,0.3-2.5,0.3
		c-0.1-0.5-0.3-1.3-0.5-1.7c0.6,0,1.3,0,1.5,0c0.2,0,0.3-0.1,0.3-0.3v-4h-3v-1.5h4.3c-0.8-0.3-1.7-0.7-2.5-0.9l0.5-0.6h-3.7v-1.6
		h4.3v-0.7H194v-1.5h3.1v-0.7h-3.8v-1.5h1.9c-0.2-0.5-0.5-1-0.8-1.4l1.6-0.6c0.4,0.5,0.9,1.3,1.1,1.8l-0.5,0.2h2.9l-0.4-0.1
		c0.3-0.5,0.7-1.4,0.9-1.9l1.9,0.5c-0.4,0.5-0.8,1-1.1,1.5h2.2v1.5h-4v0.7h3.5v1.5h-3.5v0.7h4.3v1.6h-4.5c0.8,0.3,1.7,0.6,2.3,1
		l-1.1,1.3c-0.3-0.1-0.6-0.3-0.9-0.5v0.9c0.2,0.4,0.4,0.8,0.6,1.1c0.7-0.6,1.5-1.3,2-1.9L203.4,152.2z"
          />
          <path
            fill="#F17752"
            d="M206.5,152.1c1.4-0.5,2.2-1.2,2.3-2.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.6-1.7-1.6c0-1,0.8-1.6,1.8-1.6
		c1.3,0,1.9,1,1.9,2.5c0,2-1.3,3.7-3.5,4.4L206.5,152.1z"
          />
          <path
            fill="#F17752"
            d="M220,142c-0.5,1.2-1.1,2.5-1.8,3.7V158h-2.1v-9.2c-0.5,0.6-1,1.2-1.5,1.7c-0.2-0.5-0.9-1.7-1.2-2.3
		c1.8-1.6,3.5-4.2,4.6-6.9L220,142z M225.9,150.9v4.5h4.2v2.1h-10.6v-2.1h4.2v-4.5h-4.6v-2.1h4.6v-3.9h-3.7v-2h9.8v2h-4v3.9h4.6v2.1
		H225.9z"
          />
          <path
            fill="#F17752"
            d="M237.6,141.9c-0.4,1.1-0.9,2.2-1.5,3.3V158h-2.1v-9.4c-0.4,0.6-0.8,1.1-1.3,1.5c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.1-4.1,4-6.6L237.6,141.9z M248.5,144.8h-1.1v10.7c0,1.2-0.3,1.8-1,2.2c-0.8,0.3-2,0.4-3.7,0.4c-0.1-0.6-0.4-1.6-0.7-2.2
		c1.2,0.1,2.4,0.1,2.8,0.1c0.4,0,0.5-0.1,0.5-0.5v-10.6h-7.9v-2.1h11.1V144.8z M239.6,153.3v1.2h-2v-7.7h6v6.5H239.6z M239.6,148.6
		v2.8h2v-2.8H239.6z"
          />
          <path
            fill="#F17752"
            d="M259.1,141.2c0,0.8-0.1,1.7-0.1,2.8c0.3,2.4,1.3,9.2,7.6,12c-0.7,0.5-1.3,1.2-1.6,1.9c-4-1.9-6-5.4-7-8.5
		c-1,3.2-2.9,6.4-6.6,8.6c-0.4-0.6-1.1-1.3-1.8-1.7c7.3-3.9,7-12,7-15H259.1z"
          />
          <path
            fill="#F17752"
            d="M284.6,143.1c-0.6,1.7-1.4,3.8-2.2,5.3c1.5,1.6,1.8,3,1.8,4.2c0,1.3-0.3,2.2-1,2.7c-0.3,0.3-0.8,0.4-1.3,0.5
		c-0.4,0.1-1,0.1-1.6,0c0-0.6-0.2-1.5-0.5-2.1c0.4,0,0.8,0.1,1.1,0c0.3,0,0.5-0.1,0.7-0.2c0.3-0.2,0.5-0.6,0.5-1.2
		c0-1-0.4-2.3-1.9-3.7c0.5-1.3,1.1-3.1,1.6-4.5h-2.3V158h-2.1v-15.4c-0.5,1.4-1.2,2.7-1.9,3.8h1.3v1.9h-2.7
		c-0.4,0.5-0.8,0.9-1.2,1.3h3.2v8.1h-2v-0.7h-2.9v0.9h-1.9v-5.5c-0.3,0.2-0.6,0.4-0.9,0.5c-0.2-0.5-0.8-1.4-1.2-1.8
		c1.6-0.8,3-1.8,4.3-3h-3.8v-1.9h3.1V145h-2.4v-1.8h2.4v-1.7h2v1.7h1.9v0.9c0.3-0.6,0.6-1.3,0.9-2l1.9,0.5v-0.3h5.2l0.3-0.1
		L284.6,143.1z M274.3,151.3h-2.9v1.2h2.9V151.3z M274.3,155.4v-1.3h-2.9v1.3H274.3z M273.2,146.5c0.3-0.5,0.7-1,1-1.5h-1.4v1.5
		H273.2z"
          />
          <path
            fill="#F17752"
            d="M67.4,167c-0.2,0.5-0.4,1-0.7,1.4H75v8.9c0,1.1-0.2,1.6-0.9,2c-0.7,0.3-1.7,0.4-3.2,0.4
		c-0.1-0.6-0.4-1.5-0.6-2.1c0.9,0.1,2,0.1,2.3,0.1c0.3,0,0.4-0.1,0.4-0.4v-1.1h-6.8c-0.3,1.4-0.9,2.7-2,3.6
		c-0.3-0.5-1.1-1.4-1.5-1.6c1.5-1.3,1.7-3.3,1.7-5v-1.5c-0.7,0.7-1.4,1.4-2.2,2c-0.3-0.5-1-1.3-1.4-1.7c1.8-1.2,3.3-3,4.3-5h-3.9v-2
		h4.8c0.3-0.7,0.5-1.5,0.7-2.2l2.2,0.5c-0.2,0.6-0.4,1.1-0.6,1.7h8.8v2H67.4z M73,174.4v-1.2h-6.5c0,0.4,0,0.8,0,1.2H73z M73,170.3
		h-6.5v1.1H73V170.3z"
          />
          <path
            fill="#F17752"
            d="M95.9,165.8c-0.7,0.6-1.5,1.2-2.1,1.7c0.8,0.4,1.7,0.8,2.6,1c-0.5,0.4-1,1.2-1.3,1.7c-0.7-0.2-1.4-0.5-2.1-0.9
		v1.5c0,0.4,0,0.6,0.3,0.6h0.9c0.3,0,0.7,0,0.9-0.1c0,0.4,0.1,1,0.1,1.5c-0.3,0.1-0.7,0.1-1,0.1h-1.1c-1.5,0-1.8-0.6-1.8-2.1v-1
		h-1.7c-0.1,1.3-0.5,2.6-2,3.6c-0.2-0.3-0.7-0.8-1.1-1.2v0.5H83c-0.1,0.4-0.1,0.8-0.2,1.2h3.7c0,0,0,0.5,0,0.7
		c-0.2,2.4-0.4,3.6-0.9,4.1c-0.4,0.4-0.8,0.6-1.4,0.6c-0.5,0.1-1.4,0.1-2.4,0c0-0.6-0.3-1.3-0.6-1.8c0.9,0.1,1.8,0.1,2.2,0.1
		c0.3,0,0.5,0,0.6-0.2c0.2-0.2,0.4-0.8,0.5-2h-3.8c0.3-1.2,0.5-3,0.7-4.4h3.2v-1.3h-2.6v-0.3c-0.5,0.3-1.1,0.5-1.6,0.7
		c-0.3-0.5-0.8-1.2-1.2-1.6c1.1-0.3,2.1-0.8,3-1.4c-0.5-0.4-1.1-0.8-1.7-1.1l1.2-1.1c0.6,0.3,1.4,0.7,1.9,1.1c0.4-0.4,0.7-0.7,1-1.2
		h-3.5v-1.7h4.7l0.4-0.1l1.3,0.6c-0.7,1.8-1.9,3.2-3.4,4.3h2.4v3.6c1.1-0.7,1.3-1.6,1.3-2.4v-1.3h3.4c-1.6-1.2-2.8-2.8-3.6-4.8
		l1.7-0.5c0.3,0.6,0.6,1.2,1,1.7c0.6-0.5,1.3-1.2,1.7-1.7l1.5,1.1c-0.7,0.6-1.5,1.3-2.2,1.7c0.3,0.3,0.6,0.6,1,0.8
		c0.7-0.5,1.5-1.3,2-1.9L95.9,165.8z M94.6,173.8c-0.5,1.3-1.1,2.4-2,3.2c0.8,0.5,1.5,0.9,2.1,1.3l-1.1,1.4c-0.6-0.4-1.5-1-2.4-1.6
		c-1.1,0.7-2.5,1.2-4,1.5c-0.2-0.5-0.6-1.2-0.9-1.5c1.2-0.2,2.3-0.5,3.2-1c-0.9-0.5-1.7-1-2.5-1.4l0.7-0.9h-0.4v-1.4h5.9l0.3-0.1
		L94.6,173.8z M88.6,174.8c0.8,0.4,1.6,0.8,2.4,1.3c0.4-0.4,0.8-0.8,1.1-1.3H88.6z"
          />
          <path
            fill="#F17752"
            d="M115,164.8v1.9h-11.8v3.4c0,2.9-0.4,7-2.9,9.5c-0.3-0.4-1.1-1.2-1.5-1.4c1.2-1.2,1.8-2.7,2.1-4.2
		c-0.6,0.4-1.3,0.8-2,1.2l-0.6-2c0.7-0.3,1.8-0.8,2.9-1.4c0-0.6,0-1.1,0-1.6v-0.5l-1.5,0.8c-0.2-0.9-0.7-2.3-1.2-3.4l1.5-0.8
		c0.5,0.9,1,2,1.2,2.9v-4.3h6.1c-0.1-0.5-0.3-1.1-0.4-1.6l2.3-0.4c0.2,0.6,0.5,1.4,0.7,2H115z M103.6,167.7h11.2v1.8h-4.9v1.3h4.6
		v6.8c0,0.9-0.2,1.4-0.8,1.8c-0.6,0.3-1.5,0.3-2.6,0.3c-0.1-0.6-0.4-1.4-0.7-1.9c0.7,0,1.5,0,1.7,0c0.2,0,0.3-0.1,0.3-0.3v-1.6
		L111,177c-0.4-0.5-1.2-1.3-2-2.1c-0.5,0.9-1.2,1.7-2.3,2.4c-0.3-0.4-0.8-1-1.2-1.3v3.6h-1.9v-8.9h4.2v-1.3h-4.3V167.7z
		 M105.6,175.9c1.6-0.8,2.1-2.1,2.2-3.3h-2.2V175.9z M112.3,172.6h-2.6c0,0.3-0.1,0.5-0.1,0.7c0.9,0.8,2.1,1.8,2.7,2.5V172.6z"
          />
          <path
            fill="#F17752"
            d="M133.4,165.6c0,0,0,0.7,0,1c-0.2,8-0.4,10.9-1.2,11.9c-0.5,0.7-1,0.9-1.7,1c-0.7,0.1-1.8,0.1-2.8,0
		c0-0.6-0.3-1.5-0.7-2.1c1.2,0.1,2.2,0.1,2.7,0.1c0.4,0,0.6-0.1,0.8-0.3c0.5-0.6,0.8-3.3,1-9.6h-3.9c-0.5,1.1-1,2.1-1.6,2.8
		c-0.3-0.3-0.9-0.7-1.4-1v8.4h-4.8v1.3h-1.9v-13.4h2c0.2-0.9,0.5-2.1,0.5-2.9l2.3,0.3c-0.3,0.9-0.6,1.8-0.9,2.6h2.8v2.9
		c1-1.5,1.9-3.7,2.4-5.8l2,0.5c-0.2,0.8-0.4,1.5-0.7,2.3H133.4z M122.6,167.6h-2.9v2.9h2.9V167.6z M122.6,175.9v-3.5h-2.9v3.5H122.6
		z M128.5,174.9c-0.5-1.1-1.6-2.8-2.5-4.2l1.7-1c0.9,1.2,2.1,3,2.6,4L128.5,174.9z"
          />
          <path
            fill="#F17752"
            d="M152.3,166.2h-2.1v10.7c0,1.3-0.3,1.9-1.2,2.3c-0.9,0.4-2.2,0.4-4.1,0.4c-0.1-0.6-0.6-1.7-0.9-2.3
		c1.3,0.1,2.8,0.1,3.3,0.1c0.4,0,0.6-0.1,0.6-0.5v-10.7h-11.9V164h16.2V166.2z M139.8,175.2v1.4h-2.1v-8.3h7.6v7H139.8z
		 M139.8,170.2v2.9h3.4v-2.9H139.8z"
          />
          <path
            fill="#F17752"
            d="M162.5,177.7c0,0.9-0.2,1.3-0.8,1.6c-0.6,0.3-1.4,0.3-2.5,0.3c-0.1-0.5-0.4-1.2-0.6-1.7c0.6,0,1.4,0,1.6,0
		c0.2,0,0.3-0.1,0.3-0.3v-1.8c-0.9,0.6-1.8,1.3-2.6,1.8l-0.5-1.3c-0.2,1.2-0.6,2.4-1.3,3.4c-0.3-0.4-1.1-1.2-1.5-1.4
		c1-1.4,1-3.4,1-5v-4.1h6.8V177.7z M161.5,164.2c0.8,1.3,1.7,3.1,2.1,4.1l-1.9,0.8c-0.1-0.3-0.3-0.7-0.4-1.1
		c-4.6,0.5-5.3,0.6-5.8,0.8c-0.1-0.4-0.5-1.4-0.7-1.9c0.3-0.1,0.6-0.3,1-0.7s1.5-1.8,2.1-3.2l2.2,0.6c-0.6,1-1.4,2.1-2.2,3l2.6-0.2
		c-0.3-0.5-0.5-1-0.8-1.5L161.5,164.2z M157.6,173.3c0,0.7,0,1.5-0.1,2.3c0.8-0.4,1.9-0.9,3-1.5v-0.6l-0.9,0.8
		c-0.5-0.5-1.3-1.2-2-1.7V173.3z M157.6,171.1v1.3l0.9-0.8c0.6,0.4,1.4,1.1,1.9,1.5v-2H157.6z M166.5,170.8c-2.2,0-2.7-0.8-2.7-2.8
		v-5.1h2.1v2.1h4.4v1.8h-4.4v1.2c0,0.7,0.1,0.9,0.7,0.9h2.6c0.5,0,1.3-0.1,1.7-0.1c0,0.6,0.1,1.3,0.2,1.8c-0.4,0.1-1.1,0.2-1.8,0.2
		H166.5z M168.8,177.6c0.6,0,0.7-0.3,0.8-2c0.4,0.3,1.3,0.6,1.9,0.8c-0.2,2.4-0.8,3.1-2.5,3.1h-2.6c-2.1,0-2.6-0.6-2.6-2.6v-5.7h2.1
		v1.8h4.6v1.9h-4.6v2c0,0.6,0.1,0.7,0.8,0.7H168.8z"
          />
          <path
            fill="#F17752"
            d="M177.3,174c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9S175.7,174,177.3,174z M177.3,178.5
		c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S176.4,178.5,177.3,178.5z"
          />
          <path
            fill="#F17752"
            d="M189.1,163.6c-0.5,1.3-1.1,2.5-1.8,3.7v12.3h-2.1v-9.1c-0.4,0.5-0.8,1-1.2,1.4c-0.2-0.5-0.8-1.8-1.2-2.3
		c1.7-1.6,3.3-4.1,4.2-6.7L189.1,163.6z M200,177.1v2h-11.7v-2H200z M198.7,175.3h-9.2V164h9.2V175.3z M196.3,166h-4.6v2.6h4.6V166z
		 M196.3,170.6h-4.6v2.7h4.6V170.6z"
          />
          <path
            fill="#F17752"
            d="M210.4,171.4c0,0,0,0.5,0,0.8c-0.2,4.3-0.4,6.1-0.9,6.7c-0.4,0.4-0.8,0.6-1.4,0.7c-0.5,0.1-1.3,0.1-2.2,0.1
		c0-0.6-0.2-1.3-0.5-1.9c0.7,0.1,1.4,0.1,1.8,0.1c0.3,0,0.4,0,0.6-0.2c0.3-0.3,0.4-1.5,0.6-4.3h-2c-0.4,2.5-1.3,4.8-3.2,6.4
		c-0.3-0.5-0.9-1.2-1.4-1.6c2.4-1.9,2.7-5.2,2.9-8.2h-1.8v-6.3h7.4v6.3h-3.5c0,0.5-0.1,1-0.1,1.5H210.4z M204.8,168h3.4v-2.5h-3.4
		V168z M213.7,175.1h-2.1V165h2.1V175.1z M217.9,163.2v13.9c0,1.3-0.3,1.9-1,2.2c-0.7,0.3-1.9,0.4-3.6,0.4c-0.1-0.6-0.4-1.6-0.7-2.2
		c1.2,0,2.3,0,2.7,0c0.3,0,0.5-0.1,0.5-0.4v-13.9H217.9z"
          />
          <path
            fill="#F17752"
            d="M237.3,170.9v1.2h-8.8V172c-0.1,2.5-0.6,5.5-1.8,7.6c-0.3-0.3-1.2-0.8-1.6-1c1.5-2.6,1.6-6.2,1.6-8.7v-1.3
		l-0.2,0.1c-0.1-0.2-0.3-0.4-0.5-0.6h-1.5v2.6l1.4-0.4l0.3,1.9c-0.6,0.2-1.1,0.4-1.7,0.5v4.6c0,1-0.2,1.5-0.7,1.9
		c-0.5,0.3-1.3,0.4-2.5,0.4c-0.1-0.5-0.3-1.4-0.5-2c0.6,0,1.3,0,1.5,0c0.2,0,0.3-0.1,0.3-0.3v-4l-1.7,0.5l-0.5-2.1
		c0.6-0.1,1.4-0.3,2.2-0.5v-3.1h-1.9v-2h1.9v-3.4h2v3.4h1.6v0.4c1.2-1.2,2.1-2.6,2.6-3.9l1.9,0.3c-0.1,0.3-0.3,0.6-0.4,0.8h2.5
		l0.3-0.1l1.3,0.9c-0.2,0.5-0.5,1-0.8,1.5h3.4v1.5h-1.9v0.7c0,0.3,0,0.5,0.3,0.5h0.7c0.2,0,0.8,0,1-0.1c0,0.4,0.1,0.8,0.1,1.2
		c-0.2,0.1-0.7,0.1-1.1,0.1H235c-1.3,0-1.5-0.6-1.5-1.8v-0.7h-1c-0.2,1.5-0.9,2.4-3.3,2.8c-0.1-0.3-0.3-0.6-0.5-0.9v0.4
		c0,0.3,0,0.6,0,1h3.3c-0.1-0.3-0.3-0.7-0.4-1l1.7-0.5c0.2,0.4,0.4,1,0.6,1.4H237.3z M228.6,169.1c1.4-0.2,1.8-0.7,2-1.5h-2V169.1z
		 M229.6,165.4c-0.2,0.3-0.4,0.6-0.5,0.8h2.6c0.1-0.3,0.3-0.5,0.4-0.8H229.6z M229.1,176.1h7.7v3.6h-2V179H231v0.6h-1.9V176.1z
		 M236.6,173.8h-7.3v-1.1h7.3V173.8z M229.3,174.4h7.3v1.1h-7.3V174.4z M231,177.1v0.8h3.8v-0.8H231z"
          />
          <path
            fill="#F17752"
            d="M243,169.4c-0.3,2.3-0.7,5.4-1.3,7.5l-2.2-0.9c0.6-1.9,1.2-4.6,1.4-7L243,169.4z M246.4,168v8.4
		c0,0.8,0.1,1,1,1h2.6c0.9,0,1.1-0.6,1.2-3.4c0.5,0.4,1.4,0.8,2,0.9c-0.3,3.4-0.8,4.5-3,4.5h-3c-2.3,0-3-0.7-3-3V168H246.4z
		 M246.3,163.1c1.6,1,3.9,2.6,5,3.7l-1.6,1.7c-1-1.1-3.2-2.8-4.9-3.9L246.3,163.1z M254.1,168.4c1,2.1,1.9,4.8,2.3,6.7l-2.2,0.9
		c-0.3-1.8-1.2-4.7-2.1-6.8L254.1,168.4z"
          />
          <path
            fill="#F17752"
            d="M259.7,179.7c1.4-0.5,2.2-1.2,2.3-2.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.6-1.7-1.6c0-1,0.8-1.6,1.8-1.6
		c1.3,0,1.9,1,1.9,2.5c0,2-1.3,3.7-3.5,4.4L259.7,179.7z"
          />
          <path
            fill="#F17752"
            d="M275.5,174.9c-1.4,1.7-3.5,3.6-5.4,4.8c-0.5-0.5-1.3-1.1-1.8-1.5c1.9-1,3.9-2.8,5-4.2L275.5,174.9z
		 M282.8,164.1v8.6h-12.7v-8.6H282.8z M272.3,170.7h8.2v-4.5h-8.2V170.7z M279.6,174c1.6,1.3,3.8,3.1,4.9,4.4l-2,1.3
		c-0.9-1.2-3.1-3.2-4.7-4.5L279.6,174z"
          />
          <path
            fill="#F17752"
            d="M73.6,196.4c-0.5,0.8-1,1.4-1.6,1.9c1.9,0.5,3.6,0.9,5,1.4l-1.9,1.5c-1.3-0.5-3.1-1-5.2-1.6
		c-2.1,1-4.8,1.4-8.3,1.7c-0.1-0.6-0.5-1.4-0.8-1.9c2.2-0.1,4.1-0.3,5.6-0.6c-1.2-0.2-2.3-0.5-3.5-0.7c0.4-0.5,0.9-1.1,1.4-1.7h-3.4
		v-1.8h4.6c0.3-0.6,0.6-1.1,0.9-1.6H62v-5h3.9v-1h-4.7v-1.9h15.7v1.9H72v1h4.3v5h-9.7l1.9,0.4c-0.2,0.4-0.4,0.8-0.6,1.2h4.3
		c0.1-0.3,0.3-0.7,0.4-1l2.1,0.5c-0.1,0.2-0.1,0.3-0.2,0.5h2.7v1.8H73.6z M64,191.3h1.9v-1.7H64V191.3z M66.8,196.4
		c-0.2,0.2-0.3,0.5-0.5,0.7c1.1,0.2,2.1,0.4,3.2,0.6c0.6-0.4,1.2-0.8,1.6-1.3H66.8z M67.9,187.9h2v-1h-2V187.9z M70,191.3v-1.7h-2
		v1.7H70z M72,189.6v1.7h2.2v-1.7H72z"
          />
          <path
            fill="#F17752"
            d="M84.4,185.1c-0.5,1.2-1,2.5-1.7,3.7v12.4h-2.1V192c-0.4,0.5-0.8,1-1.2,1.5c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L84.4,185.1z M90.8,189.6v9.2c0,1-0.2,1.6-0.8,2c-0.6,0.3-1.5,0.4-2.6,0.4c-0.1-0.6-0.4-1.6-0.7-2.2
		c0.8,0,1.5,0,1.8,0c0.2,0,0.3-0.1,0.3-0.3v-9.2h-2.1c-0.5,1-1.1,2-1.7,2.8c-0.4-0.4-1.2-1.1-1.7-1.4c1.4-1.5,2.4-4,3.1-6.5l2.1,0.5
		c-0.2,0.9-0.5,1.8-0.8,2.7h6.2l0.3-0.1l1.5,0.3c-0.2,1.5-0.5,3.1-0.8,4.2l-1.8-0.3c0.1-0.6,0.2-1.3,0.3-2.1H90.8z M87.8,192.9
		c-0.5,2.3-1.4,4.6-2.4,6c-0.4-0.3-1.3-0.9-1.8-1.2c1-1.3,1.8-3.3,2.2-5.3L87.8,192.9z M93.3,192.3c0.9,1.9,1.7,4.2,2,5.9l-2.1,0.7
		c-0.2-1.6-1-4.1-1.8-5.9L93.3,192.3z"
          />
          <path
            fill="#F17752"
            d="M103.5,194.9v4.6c0,0.8-0.1,1.2-0.6,1.5c-0.5,0.3-1.1,0.3-2,0.3c-0.1-0.5-0.3-1.2-0.5-1.6c0.5,0,1,0,1.2,0
		c0.2,0,0.2-0.1,0.2-0.2v-4.5h-1.9v-6.5h1.6c0.1-0.5,0.1-0.9,0.2-1.4h-2.5v5.1c0,2.7-0.2,6.6-1.3,8.9c-0.3-0.3-1.1-0.9-1.5-1.1
		c0.9-2.2,1-5.4,1-7.8v-7h7.9v1.8h-1.6c-0.1,0.5-0.3,1-0.4,1.4h2.1v6.5H103.5z M101.5,196c-0.3,1.4-0.7,2.8-1.2,3.8
		c-0.3-0.3-1-0.6-1.4-0.8c0.5-0.8,0.9-2.1,1.1-3.3L101.5,196z M103.7,189.8h-2.2v1.1h2.2V189.8z M101.5,193.4h2.2v-1.1h-2.2V193.4z
		 M104.6,198.9c-0.2-0.7-0.6-2-1-2.9l1.4-0.5c0.4,0.9,0.9,2.1,1,2.8L104.6,198.9z M109.2,198.8c-0.8,0.9-2.2,1.9-3.3,2.4
		c-0.3-0.4-0.9-0.9-1.3-1.3c1.1-0.5,2.3-1.4,3-2.2L109.2,198.8z M108.3,188.2c0.1-0.4,0.1-0.8,0.2-1.3h-2.8v-1.8h7.6v1.8h-2.8
		c-0.1,0.4-0.3,0.9-0.4,1.3h2.8v9.5h-6.8v-9.5H108.3z M111,189.8h-3.1v1.2h3.1V189.8z M111,192.4h-3.1v1.2h3.1V192.4z M111,195h-3.1
		v1.2h3.1V195z M111.3,197.8c0.8,0.7,1.9,1.7,2.4,2.3l-1.6,1.1c-0.5-0.7-1.5-1.7-2.4-2.4L111.3,197.8z"
          />
          <path
            fill="#F17752"
            d="M114.8,199.8c0.9-0.8,1.7-2,2.2-3.1l1.8,0.8c-0.5,1.1-1.3,2.4-2.2,3.3L114.8,199.8z M130.9,190h-15.6v-1.7h3.8
		c-0.1-0.3-0.2-0.7-0.4-1l1.4-0.3h-3.9v-1.7h5.8c-0.1-0.3-0.2-0.6-0.3-0.8l2.1-0.4c0.2,0.4,0.4,0.8,0.5,1.2h5.6v1.7h-3.7l1.4,0.3
		c-0.2,0.4-0.4,0.7-0.6,1h3.8V190z M128.9,196.1h-5.5c0.7,0.4,1.4,0.8,1.9,1.2l-1.3,1.3c-0.6-0.6-1.8-1.3-2.8-1.8l0.7-0.7h-4.6v-5.5
		h11.6V196.1z M124.7,199.3c0.7,0,0.8-0.2,0.9-1.5c0.4,0.3,1.3,0.6,1.8,0.7c-0.2,2-0.8,2.5-2.5,2.5H122c-2.3,0-2.8-0.5-2.8-2.2v-1.9
		h2.1v1.9c0,0.5,0.1,0.5,1,0.5H124.7z M126.8,192h-7.5v0.8h7.5V192z M126.8,194h-7.5v0.8h7.5V194z M120.7,187.1
		c0.2,0.4,0.4,0.9,0.5,1.3h3.7c0.2-0.4,0.4-0.9,0.5-1.3H120.7z M128.9,196.5c0.9,1,1.8,2.3,2.2,3.2l-1.9,0.8
		c-0.3-0.9-1.2-2.3-2.1-3.3L128.9,196.5z"
          />
          <path
            fill="#F17752"
            d="M149.1,187.4c-0.7,0.6-1.5,1.2-2.1,1.7c0.8,0.4,1.7,0.8,2.6,1c-0.5,0.4-1,1.2-1.3,1.7
		c-0.7-0.2-1.4-0.5-2.1-0.9v1.5c0,0.4,0,0.6,0.3,0.6h0.9c0.3,0,0.7,0,0.9-0.1c0,0.4,0.1,1,0.1,1.5c-0.3,0.1-0.7,0.1-1,0.1h-1.1
		c-1.5,0-1.8-0.6-1.8-2.1v-1h-1.7c-0.1,1.3-0.5,2.6-2,3.6c-0.2-0.3-0.7-0.8-1.1-1.2v0.5h-3.6c-0.1,0.4-0.1,0.8-0.2,1.2h3.7
		c0,0,0,0.5,0,0.7c-0.2,2.4-0.4,3.6-0.9,4.1c-0.4,0.4-0.8,0.6-1.4,0.6c-0.5,0.1-1.4,0.1-2.4,0c0-0.6-0.3-1.3-0.6-1.8
		c0.9,0.1,1.8,0.1,2.2,0.1c0.3,0,0.5,0,0.6-0.2c0.2-0.2,0.4-0.8,0.5-2H134c0.3-1.2,0.5-3,0.7-4.4h3.2v-1.3h-2.6v-0.3
		c-0.5,0.3-1.1,0.5-1.6,0.7c-0.3-0.5-0.8-1.2-1.2-1.6c1.1-0.3,2.1-0.8,3-1.4c-0.5-0.4-1.1-0.8-1.7-1.1l1.2-1.1
		c0.6,0.3,1.4,0.7,1.9,1.1c0.4-0.4,0.7-0.7,1-1.2h-3.5v-1.7h4.7l0.4-0.1l1.3,0.6c-0.7,1.8-1.9,3.2-3.4,4.3h2.4v3.6
		c1.1-0.7,1.3-1.6,1.3-2.4v-1.3h3.4c-1.6-1.2-2.8-2.8-3.6-4.8l1.7-0.5c0.3,0.6,0.6,1.2,1,1.7c0.6-0.5,1.3-1.2,1.7-1.7l1.5,1.1
		c-0.7,0.6-1.5,1.3-2.2,1.7c0.3,0.3,0.6,0.6,1,0.8c0.7-0.5,1.5-1.3,2-1.9L149.1,187.4z M147.8,195.4c-0.5,1.3-1.1,2.4-2,3.2
		c0.8,0.5,1.5,0.9,2.1,1.3l-1.1,1.4c-0.6-0.4-1.5-1-2.4-1.6c-1.1,0.7-2.5,1.2-4,1.5c-0.2-0.5-0.6-1.2-0.9-1.5c1.2-0.2,2.3-0.5,3.2-1
		c-0.9-0.5-1.7-1-2.5-1.4l0.7-0.9h-0.4V195h5.9l0.3-0.1L147.8,195.4z M141.8,196.4c0.8,0.4,1.6,0.8,2.4,1.3c0.4-0.4,0.8-0.8,1.1-1.3
		H141.8z"
          />
          <path
            fill="#F17752"
            d="M165.7,186.8v14.5h-2.3v-0.9h-8.6v0.9h-2.2v-14.5h4.6c0.2-0.8,0.4-1.6,0.5-2.4l2.6,0.3
		c-0.3,0.7-0.6,1.4-0.8,2.1H165.7z M154.8,188.8v1.9h8.6v-1.9H154.8z M154.8,192.6v1.9h8.6v-1.9H154.8z M163.4,198.3v-1.9h-8.6v1.9
		H163.4z"
          />
          <path
            fill="#F17752"
            d="M184.4,198.7c0,1.2-0.2,1.8-1,2.1c-0.8,0.3-1.9,0.4-3.5,0.4c-0.1-0.6-0.4-1.6-0.7-2.2c1,0,2.2,0,2.5,0
		c0.3,0,0.4-0.1,0.4-0.4v-3.2c-0.4,0.5-0.9,1.1-1.2,1.5c-1.9-1.1-3.1-2.8-3.9-4.9c-0.8,2.2-2.1,3.9-4.1,5c-0.2-0.3-0.6-0.9-1-1.3
		v5.4h-2.2v-12.8h6.4c-0.1-0.5-0.1-0.9-0.1-1.4h-3v-1.9h4.9c0,1.2,0.1,2.2,0.3,3.3h6.1V198.7z M172,195.2c1.8-1,2.9-2.6,3.5-4.7H172
		V195.2z M178.8,190.5c0.6,2,1.7,3.5,3.4,4.5v-4.5H178.8z"
          />
          <path
            fill="#F17752"
            d="M190.2,191c-0.3,2.3-0.7,5.4-1.3,7.5l-2.2-0.9c0.6-1.9,1.2-4.6,1.4-7L190.2,191z M193.6,189.6v8.4
		c0,0.8,0.1,1,1,1h2.6c0.9,0,1.1-0.6,1.2-3.4c0.5,0.4,1.4,0.8,2,0.9c-0.3,3.4-0.8,4.5-3,4.5h-3c-2.3,0-3-0.7-3-3v-8.4H193.6z
		 M193.5,184.7c1.6,1,3.9,2.6,5,3.7l-1.6,1.7c-1-1.1-3.2-2.8-4.9-3.9L193.5,184.7z M201.3,190c1,2.1,1.9,4.8,2.3,6.7l-2.2,0.9
		c-0.3-1.8-1.2-4.7-2.1-6.8L201.3,190z"
          />
          <path
            fill="#F17752"
            d="M214,187.5c-0.2,0.6-0.3,1.1-0.5,1.6h6.8v12.2h-2.2v-0.9h-10.4v0.9h-2.1v-12.2h5.5c0.1-0.5,0.2-1.1,0.3-1.6
		H205v-2h16.2v2H214z M207.8,198.4h1.8v-7.3h-1.8V198.4z M214.3,191.1h-2.8v1.2h2.8V191.1z M214.3,194h-2.8v1.4h2.8V194z
		 M211.6,198.4h2.8V197h-2.8V198.4z M218.2,191.1h-1.9v7.3h1.9V191.1z"
          />
          <path
            fill="#F17752"
            d="M228.4,198.1c1.1-0.1,2.3-0.3,3.5-0.4l0,1.9c-3.1,0.4-6.4,0.8-8.8,1l-0.3-1.9c1-0.1,2.3-0.2,3.6-0.3v-1.3h-2.7
		v-1.7h2.7V194h-3v-1.7h1.9c-0.3-0.5-0.7-1.2-1.2-1.7l0.9-0.5h-2.3v-1.8h2.4v-0.8l-0.9,0.6c-0.3-0.6-0.9-1.5-1.5-2.2l1.3-0.8
		c0.4,0.4,0.8,0.9,1.1,1.3v-1.9h1.7v3.8h0.8v-3.8h1.7v2.1c0.4-0.5,0.8-1,1-1.4l1.7,0.9c-0.7,0.8-1.5,1.5-2.1,2.1l-0.6-0.4v0.5h2.3
		v1.8h-2.3l1.2,0.4c-0.3,0.6-0.6,1.2-1,1.8h1.6v1.7h-2.9v1.2h2.7v1.7h-2.7V198.1z M225.9,190c0.4,0.5,0.9,1.1,1,1.6l-1.1,0.6h1.9
		c0.3-0.6,0.8-1.5,1-2.2H225.9z M239.2,191h-1.4v7.9c0,1.1-0.2,1.6-0.9,2c-0.6,0.4-1.6,0.4-3,0.4c-0.1-0.6-0.4-1.5-0.7-2
		c0.9,0,1.8,0,2.1,0c0.3,0,0.4-0.1,0.4-0.4V191h-3.9v-2h3.9v-4.5h2.1v4.5h1.4V191z M233.4,196.6c-0.1-1.1-0.7-2.8-1.3-4.1l1.8-0.6
		c0.7,1.3,1.3,2.9,1.4,4L233.4,196.6z"
          />
          <path
            fill="#F17752"
            d="M242.1,201.3c1.4-0.5,2.2-1.2,2.3-2.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.6-1.7-1.6c0-1,0.8-1.6,1.8-1.6
		c1.3,0,1.9,1,1.9,2.5c0,2-1.3,3.7-3.5,4.4L242.1,201.3z"
          />
          <path
            fill="#F17752"
            d="M252.9,195c-0.4,1.8-1.1,3.6-1.8,4.8c-0.3-0.3-1.1-0.8-1.5-1c0.7-1,1.2-2.6,1.5-4.2L252.9,195z M258.1,188.4
		h-8.2v-1.9h3.4c-0.2-0.5-0.4-1.2-0.6-1.7l2-0.4c0.3,0.6,0.6,1.4,0.8,2.1h2.7V188.4z M255.2,194.1v5.1c0,0.9-0.1,1.3-0.7,1.6
		c-0.5,0.3-1.2,0.3-2.2,0.3c-0.1-0.5-0.3-1.3-0.6-1.8c0.6,0,1.2,0,1.3,0c0.2,0,0.3-0.1,0.3-0.2v-5h-2.6v-4.8h6.8v4.8H255.2z
		 M252.5,192.4h3v-1.5h-3V192.4z M256.9,194.4c0.6,1,1.1,2.3,1.3,3.2l-1.6,0.7c-0.2-0.9-0.7-2.3-1.2-3.3L256.9,194.4z M264.5,199.3
		c0.1,0,0.3,0,0.3-0.1c0.1,0,0.1-0.2,0.2-0.5c0.1-0.3,0.1-1,0.1-2c0.4,0.4,1.1,0.7,1.6,0.9c0,0.8-0.1,1.8-0.2,2.2
		c-0.1,0.4-0.4,0.7-0.7,0.8c-0.3,0.2-0.7,0.2-1.1,0.2h-1.1c-0.4,0-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.9v-4.1
		c-0.6,2.6-1.6,5.1-3.5,6.9c-0.3-0.5-0.9-1-1.5-1.3c2.4-2.2,3.3-5.5,3.6-9.1h-2.1V189h2.3c0.1-1.5,0.1-3.1,0.1-4.5h2
		c0,1.5,0,3-0.1,4.5h3.8v1.9h-3.9c0,0.3-0.1,0.6-0.1,0.9h1.4v6.8c0,0.3,0,0.5,0.1,0.6c0.1,0.1,0.1,0.1,0.3,0.1H264.5z M264.6,188.7
		c-0.3-0.8-1.1-2-1.8-2.9l1.4-0.8c0.7,0.8,1.5,2,1.9,2.8L264.6,188.7z"
          />
          <path
            fill="#F17752"
            d="M274.4,188.6c-0.2,0.5-0.4,1-0.7,1.4h8.4v8.9c0,1.1-0.2,1.6-0.9,2c-0.7,0.3-1.7,0.4-3.2,0.4
		c-0.1-0.6-0.4-1.5-0.6-2.1c0.9,0.1,2,0.1,2.3,0.1c0.3,0,0.4-0.1,0.4-0.4v-1.1h-6.8c-0.3,1.4-0.9,2.7-2,3.6
		c-0.3-0.5-1.1-1.4-1.5-1.6c1.5-1.3,1.7-3.3,1.7-5v-1.5c-0.7,0.7-1.4,1.4-2.2,2c-0.3-0.5-1-1.3-1.4-1.7c1.8-1.2,3.3-3,4.3-5h-3.9v-2
		h4.8c0.3-0.7,0.5-1.5,0.7-2.2l2.2,0.5c-0.2,0.6-0.4,1.1-0.6,1.7h8.8v2H274.4z M280,196v-1.2h-6.5c0,0.4,0,0.8,0,1.2H280z
		 M280,191.9h-6.5v1.1h6.5V191.9z"
          />
          <path
            fill="#F17752"
            d="M65,216.2c-0.1-0.4-0.4-1.1-0.7-1.7v8.4h-1.8v-7c-0.4,1.3-0.8,2.4-1.2,3.2c-0.2-0.6-0.6-1.6-0.8-2.1
		c0.8-1.3,1.5-3.6,1.9-5.6h-1.5v-2h1.6V206h1.8v3.3h1.2v2h-1.2v0.8c0.4,0.6,1.4,2.2,1.7,2.6L65,216.2z M76.4,217.5
		c-0.5,1-1.2,1.9-2,2.6c0.3,0.4,0.7,0.6,1.1,0.6c0.3,0,0.6-0.6,0.7-1.9c0.3,0.4,1,0.9,1.4,1.1c-0.5,2.2-1.2,2.9-2,2.8
		c-1.1-0.1-1.9-0.6-2.6-1.5c-0.8,0.6-1.8,1.1-2.8,1.5c-0.2-0.4-0.7-1-1.1-1.4c1.2-0.4,2.2-1,3.1-1.6c-0.4-0.8-0.7-1.8-0.9-2.9h-2.4
		c0,0.1,0,0.3,0,0.4c0.7,0.6,1.8,1.4,2.3,1.9l-1.3,1.3c-0.3-0.4-0.8-0.8-1.4-1.3c-0.4,1.3-1.2,2.6-2.4,3.6c-0.3-0.3-1-1-1.4-1.2
		c1.9-1.4,2.4-3.2,2.4-4.7h-1.1v-1.6h5c-0.3-1.8-0.5-4-0.6-6.3c-0.7,1.3-1.6,2.7-2.4,3.7l1-0.1c-0.1-0.3-0.2-0.6-0.2-0.8l1.2-0.3
		c0.3,0.8,0.6,1.9,0.7,2.6l-1.3,0.4c0-0.2-0.1-0.4-0.1-0.6c-2.2,0.3-2.6,0.5-2.8,0.6c-0.1-0.3-0.3-1.1-0.5-1.5
		c0.3-0.1,0.6-0.4,0.9-0.8c0.2-0.2,0.5-0.7,0.9-1.3c-1,0.1-1.3,0.2-1.4,0.3c-0.1-0.3-0.3-1-0.5-1.4c0.2-0.1,0.5-0.3,0.6-0.6
		c0.2-0.3,0.9-1.6,1.2-2.9l1.5,0.4c-0.4,1-1,2.1-1.5,3l0.8-0.1c0.2-0.4,0.4-0.7,0.5-1.1l1.5,0.5c0-0.9-0.1-1.8-0.1-2.7h1.8
		c0.1,3.5,0.3,6.7,0.8,9.1h1.7c-0.3-0.3-0.6-0.5-0.9-0.8l0.8-0.7c-0.8,0.1-1.1,0.2-1.3,0.3c-0.1-0.3-0.3-1.1-0.5-1.5
		c0.3-0.1,0.6-0.4,0.9-0.8c0.2-0.2,0.5-0.7,0.8-1.3c-0.9,0.1-1.2,0.2-1.4,0.3c-0.1-0.3-0.3-1-0.5-1.4c0.2-0.1,0.4-0.3,0.6-0.6
		c0.2-0.3,0.8-1.5,1.1-2.7l1.5,0.4c-0.4,1-0.9,2-1.4,2.8l0.8-0.1c0.2-0.4,0.3-0.8,0.5-1.1l1.5,0.5c-0.7,1.4-1.5,2.7-2.4,3.8l1-0.1
		c-0.1-0.3-0.2-0.5-0.3-0.8l1.2-0.3c0.3,0.8,0.7,2,0.8,2.6l-1.3,0.5c0-0.2-0.1-0.5-0.2-0.7c-0.5,0.1-0.8,0.1-1.1,0.2
		c0.5,0.4,1.1,0.8,1.4,1.1l-0.5,0.4h1.4v1.6H75L76.4,217.5z M73,216.9c0.1,0.6,0.3,1.1,0.5,1.6c0.4-0.5,0.8-1,1.1-1.6H73z"
          />
          <path
            fill="#F17752"
            d="M88.6,206.6c-0.1,0.1-0.2,0.2-0.3,0.3c1.7,1.4,4.6,2.7,7.5,3.2c-0.5,0.4-1.1,1.1-1.4,1.6
		c-0.4-0.1-0.7-0.2-1.1-0.3v4.6H80.8v-4.5c-0.4,0.1-0.8,0.3-1.1,0.3c-0.2-0.4-0.8-1.3-1.2-1.7c3.3-0.8,6.5-2.3,8.2-4.4L88.6,206.6z
		 M92.7,211.2c-0.8-0.3-1.7-0.7-2.4-1.1v0.5h-6.3v-0.4c-0.7,0.4-1.4,0.7-2.2,1H92.7z M81.8,216.7h10.6v6.1h-2.2v-0.4h-6.3v0.5h-2.1
		V216.7z M83.8,214.8c-0.1-0.6-0.3-1.3-0.6-1.9l1.4-0.4h-2v2.3H83.8z M83.9,218.1v0.7h6.3v-0.7H83.9z M90.2,220.9v-0.7h-6.3v0.7
		H90.2z M86.1,212.5h-1.4c0.3,0.6,0.6,1.4,0.7,1.9l-1.2,0.4h1.8V212.5z M88.7,209.2c-0.5-0.4-1.1-0.8-1.5-1.2
		c-0.5,0.4-1,0.8-1.5,1.2H88.7z M87.8,212.5v2.3h1.7l-1.1-0.3c0.3-0.5,0.5-1.4,0.7-2H87.8z M91.4,212.5h-1.9l1.4,0.3
		c-0.4,0.7-0.7,1.4-1,1.9h1.5V212.5z"
          />
          <path
            fill="#F17752"
            d="M112.3,212.3c-0.7,2.3-1.8,4.4-3.1,6.2c0.5,1.3,1.1,2.1,1.7,2.1c0.4,0,0.6-0.9,0.7-3.2c0.5,0.5,1.2,1,1.8,1.2
		c-0.3,3.3-1.1,4.1-2.7,4.1c-1.3,0-2.3-0.9-3-2.4c-0.9,1-1.9,1.8-3,2.4c-0.3-0.5-1.1-1.3-1.5-1.8c1.4-0.8,2.6-1.7,3.7-2.9
		c-0.6-2-1-4.6-1.2-7.3h-5.2v1.9h4.4c0,0,0,0.6,0,0.8c-0.1,3.8-0.2,5.4-0.6,5.9c-0.3,0.5-0.7,0.6-1.2,0.7c-0.5,0.1-1.2,0.1-2.1,0.1
		c0-0.6-0.3-1.5-0.6-2c0.6,0.1,1.3,0.1,1.5,0.1c0.3,0,0.4,0,0.5-0.2c0.2-0.3,0.3-1.1,0.3-3.4h-2.3c-0.1,2.6-0.5,6.1-1.9,8.3
		c-0.4-0.4-1.3-1.2-1.8-1.5c1.4-2.2,1.5-5.3,1.5-7.6v-5.3h7.3c0-0.9-0.1-1.8-0.1-2.7h2.3c0,0.9,0,1.8,0,2.7h2.8
		c-0.7-0.5-1.6-1.1-2.3-1.6l1.3-1.3c1,0.5,2.3,1.3,2.9,1.9l-0.9,0.9h1.9v2.1h-5.6c0.2,1.8,0.4,3.5,0.7,4.9c0.7-1.2,1.3-2.5,1.7-4
		L112.3,212.3z"
          />
          <path
            fill="#F17752"
            d="M122,217.8c-2.4,0.7-5,1.4-7,2l-0.5-2.2c0.7-0.2,1.6-0.4,2.6-0.6v-7h-2.3v-2h6.8v2h-2.3v6.5
		c0.8-0.2,1.7-0.4,2.5-0.6L122,217.8z M131,209.8c0,0,0,0.7,0,1c-0.2,7.3-0.4,9.9-1.1,10.8c-0.5,0.6-0.9,0.8-1.6,1
		c-0.6,0.1-1.6,0.1-2.6,0.1c0-0.6-0.3-1.5-0.6-2.1c0.9,0.1,1.8,0.1,2.2,0.1c0.3,0,0.5-0.1,0.7-0.3c0.4-0.5,0.6-2.8,0.8-8.4h-2.4
		c-0.3,4.8-1.4,8.6-5.3,11c-0.3-0.6-1-1.3-1.5-1.7c3.5-2,4.4-5.1,4.6-9.2h-2.4v-2.1h2.5c0-1.1,0-2.3,0-3.5h2.2c0,1.2,0,2.4,0,3.5
		H131z"
          />
          <path
            fill="#F17752"
            d="M136,214.7c-0.7-0.5-2.3-1.4-3.4-1.9l1.2-1.6c1.1,0.5,2.6,1.2,3.4,1.8L136,214.7z M133.1,221.2
		c1-1.4,2.3-3.6,3.4-5.7l1.6,1.4c-0.9,1.9-2.1,3.9-3.2,5.7L133.1,221.2z M137.1,209.8c-0.7-0.6-2.3-1.4-3.3-2l1.2-1.5
		c1.1,0.5,2.6,1.3,3.4,1.8L137.1,209.8z M147.4,214.4c-0.1-0.3-0.3-0.7-0.5-1c-7,0.5-8,0.6-8.7,0.8c-0.1-0.4-0.5-1.4-0.7-2
		c0.4-0.1,0.7-0.5,1.2-1.1c0.5-0.6,1.9-2.9,2.8-5.1l2.2,0.6c-0.8,1.8-1.9,3.6-3,5.1l5.1-0.3c-0.6-0.9-1.2-1.7-1.8-2.5l1.8-0.9
		c1.4,1.6,2.9,3.8,3.6,5.2L147.4,214.4z M138.7,215.3h9.3v7.5h-2.2v-0.7h-5.1v0.8h-2.1V215.3z M140.7,217.3v2.8h5.1v-2.8H140.7z"
          />
          <path
            fill="#F17752"
            d="M162.4,209.9c2,0.9,3.8,1.3,5.1,1.5c-0.4,0.4-0.9,1-1.1,1.5c-0.8-0.2-1.7-0.5-2.8-1v0.8h-4.7v-0.6
		c-0.9,0.4-1.8,0.7-2.7,1c-0.2-0.4-0.5-0.8-0.9-1.2v1.5c0,2.9-0.4,7.1-2.7,9.6c-0.3-0.4-1.1-1.2-1.5-1.4c1.2-1.3,1.7-3,2-4.7
		c-0.6,0.4-1.3,0.8-1.9,1.2l-0.6-1.9c0.7-0.3,1.7-0.8,2.7-1.3c0-0.5,0-1,0-1.4v-0.6l-1.6,0.7c-0.1-1-0.5-2.5-1-3.6l1.5-0.6
		c0.5,1,0.9,2.3,1,3.2v-4.8h6.2c-0.1-0.4-0.3-0.9-0.4-1.2l2.2-0.4c0.2,0.5,0.4,1.1,0.6,1.6h5.5v1.8h-5.5l0.7,0.4L162.4,209.9z
		 M154.5,221.6c0.6-0.6,1.2-1.7,1.5-2.6l1.6,0.7c-0.4,0.9-0.9,2.1-1.5,2.8L154.5,221.6z M155.2,211.5c1.9-0.5,4-1.2,5.3-2.2h-5.3
		V211.5z M161,217.3c0,0.6-0.1,0.8-0.5,1c-0.4,0.2-0.9,0.2-1.7,0.2c0-0.3-0.2-0.7-0.4-1c0.4,0,0.7,0,0.9,0s0.2,0,0.2-0.2V217h-1.9
		c-0.1,0.6-0.4,1.2-1,1.7c-0.3-0.3-0.9-0.8-1.3-1c0.8-0.6,0.8-1.4,0.8-2.2v-2.3h4.8V217.3z M159.4,216.1v-0.5h-1.8
		c0,0.2,0,0.3,0,0.5H159.4z M157.7,214.2v0.5h1.8v-0.5H157.7z M162.3,221.2c0.5,0,0.6-0.1,0.6-1.1c0.3,0.2,1,0.4,1.5,0.5
		c-0.2,1.5-0.6,1.9-1.9,1.9h-2.4c-1.8,0-2.3-0.4-2.3-1.8v-1.7h1.7v1.7c0,0.4,0.1,0.5,0.7,0.5H162.3z M162.7,211.5
		c-0.5-0.2-1-0.5-1.5-0.8c-0.4,0.3-0.8,0.5-1.3,0.8H162.7z M161.3,218.1c0.6,0.5,1.3,1.2,1.7,1.7l-1.4,0.9c-0.4-0.5-1.1-1.2-1.7-1.7
		L161.3,218.1z M161.7,213.2h1.5v3.5h-1.5V213.2z M166,217c0,0.8-0.1,1.1-0.6,1.3c-0.5,0.2-1.2,0.2-2.1,0.2c-0.1-0.4-0.3-1-0.5-1.4
		c0.6,0,1.1,0,1.3,0c0.2,0,0.2-0.1,0.2-0.2v-4h1.7V217z M165.3,218.9c0.7,0.8,1.5,2,1.8,2.8l-1.6,0.8c-0.3-0.7-1.1-2-1.7-2.8
		L165.3,218.9z"
          />
          <path
            fill="#F17752"
            d="M172.6,217.2c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9S171,217.2,172.6,217.2z
		 M172.6,221.7c0.9,0,1.6-0.7,1.6-1.6s-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6S171.7,221.7,172.6,221.7z"
          />
          <path fill="#F17752" d="M183.5,222.9h-6V221h3.8v-9.6h2.1V222.9z" />
        </g>
      </svg>
    );
  }
}

export default DialogGText;



// WEBPACK FOOTER //
// ./src/storyA/components/DialogGText.tsx